import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';

/**
 * TopBar — barra superior com slogan e redes sociais (extraída do Home).
 */
export default function TopBar() {
  return (
    <div className="hidden bg-primary-dark text-white md:block">
      <div className="app-container flex h-10 items-center justify-between text-xs">
        <p className="font-medium tracking-wide">
          “Existimos para pregar o Evangelho e fazer discípulos em Caratinga.”
        </p>
        <div className="flex items-center gap-4">
          <a href="#" className="flex items-center gap-1.5 transition-opacity hover:opacity-80">
            <Facebook size={14} /> Facebook
          </a>
          <a href="#" className="flex items-center gap-1.5 transition-opacity hover:opacity-80">
            <Instagram size={14} /> Instagram
          </a>
          <a href="#" className="flex items-center gap-1.5 transition-opacity hover:opacity-80">
            <Youtube size={14} /> YouTube
          </a>
        </div>
      </div>
    </div>
  );
}
